const paths = {
  //Single paths
  "path.progress": "Progress",
  "path.activity": "Activity",
  "path.leaderboard": "Leaderboard",
  "path.latest": "Feed",
  "path.challenges": "Challenges",
  "path.team": "Team",
  "path.set": "Set Results",
  "path.settings": "Settings",
  "path.session": "Session Results",
  "path.scenario": "Scenario Results",

  "path.account": "Account Info",
  "path.privacy": "Privacy & Sharing",
  "path.security": "Security",
  "path.billing": "Billing",
  "path.members": "Team Management",
  "path.help": "Help & Support",
  "path.about": "About",
  "path.password": "Password Settings",
  "path.pin": "Pin Settings",
  "path.admin": "Super Admin",
  "path.users": "Users Admin",
  "path.teams": "Teams Admin",
  "path.clubs": "Clubs Admin",
  "path.training": "Training Settings",
  "path.bybcat": "BYBCAT",
  "path.bybcat.users": "Users",
  "path.configs": "Test Configurations",
  "path.results": "Results",
};

export default paths;
